var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('embeddable-footer',{staticClass:"embed_footer",attrs:{"home-url":"https://www.icij.org/investigations/luanda-leaks","title":"Luanda Leaks","sharing-options-values":_vm.sharingOptionsValues}})}
var staticRenderFns = []

export { render, staticRenderFns }